import { render, staticRenderFns } from "./InspectionCardV2.vue?vue&type=template&id=8baec2f4&scoped=true&"
import script from "./InspectionCardV2.vue?vue&type=script&lang=ts&"
export * from "./InspectionCardV2.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionCardV2.vue?vue&type=style&index=0&id=8baec2f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8baec2f4",
  null
  
)

export default component.exports